import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import { EditableText } from "../../EditableText";
import type { PDFPreviewFormData } from "../pdfPreview.types";

interface PDFCategoryGroupedEditorProps {
  control: Control<PDFPreviewFormData>;
}

export function PDFCategoryGroupedEditor({ control }: PDFCategoryGroupedEditorProps) {
  return (
    <Controller
      name="scopeNoteText"
      control={control}
      render={({ field: { onChange, value } }) => (
        <EditableText
          value={value}
          onChange={onChange}
          displayAs="div"
          inputType="textarea"
          displayClassName="text-sm leading-relaxed whitespace-pre-wrap pl-6 py-1"
          editClassName="text-sm w-full min-h-[200px] resize-y ml-6 leading-relaxed whitespace-pre-wrap px-2 py-1"
        />
      )}
    />
  );
}
